import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useT } from "@/i18n";

export default function PaymentCancel() {
  const nav = useNavigate();
  const { t } = useT();
  return (
    <div className="min-h-screen w-full grid-bg flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-black/60 backdrop-blur-2xl border border-white/10 p-10 text-center">
        <div className="flex flex-col items-center gap-4">
          <XCircle className="text-white/60" size={48} />
          <div className="font-display text-3xl tracking-tighter">{t("payment.canceled")}</div>
          <div className="text-sm text-white/60 tracking-wide">{t("payment.canceled_desc")}</div>
          <button
            data-testid="cancel-back-button"
            onClick={() => nav("/")}
            className="mt-4 px-6 py-3 border border-cyan-300 text-cyan-300 hover:bg-cyan-300 hover:text-black transition-colors text-xs tracking-[0.3em]"
          >
            {t("payment.back_menu")}
          </button>
        </div>
      </div>
    </div>
  );
}
